import React, { FC } from 'react'
import { useIntl } from 'react-intl'
import { FieldRenderProps } from 'react-final-form'
import { fontFamilyMonserrat } from '../../theme'
import { formLabelClasses, Grid, outlinedInputClasses, styled, TextField as MuiTextField } from '@mui/material'
import { ErrorContainer } from './utils/styledComponents'

interface AcceptingProps {
	label: string
	placeholder?: string
	multiline?: boolean
}

type TextFieldProps = AcceptingProps & FieldRenderProps<string[]>

const TextField: FC<TextFieldProps> = (
	{
		label,
		placeholder,
		input,
		meta: { touched, error },
		multiline= false
	}) => {
	const intl = useIntl()

	return (
		<TextFieldContainer container item multiline={multiline}>
			<CustomTextField
				{...input}
				label={intl.formatMessage({ id: label })}
				placeholder={!!placeholder ? intl.formatMessage({ id: placeholder }) : undefined}
				multiline={multiline}
				focused
			/>
			{touched && error && <Grid item><ErrorContainer>{error}</ErrorContainer></Grid>}
		</TextFieldContainer>
	)
}

const CustomTextField = styled(MuiTextField)(({ theme }) => ({
	[`.${outlinedInputClasses.input}`]: {
		...theme.typography.text8
	},
	[`.${outlinedInputClasses.root}`]: {
		'&.Mui-focused fieldset': {
			color: theme.palette.blue['50'],
			borderColor: theme.palette.blue['50'],
			borderWidth: 1
		}
	},
	[`.${formLabelClasses.root}`]: {
		'&.Mui-focused': {
			color: theme.palette.blue['50'],
			fontFamily: fontFamilyMonserrat,
			paddingLeft: 8
		}
	},
	'& fieldset': {
		paddingLeft: 16,
		'& legend': {
			fontSize: 12
		}
	}
}))

interface TextFieldContainerProps {
	multiline: boolean
}

const TextFieldContainer = styled(Grid)<TextFieldContainerProps>(({ multiline }) => ({
	flexDirection: 'column',
	height: multiline? 'fit-content' : 54
}))

export default TextField